import { useEffect, useState } from "react";
import PostItem from "../components/PostItem";
import { useParams } from "react-router-dom";
import { BASE_URL } from "../contexts/UserContext";
import axios from "axios";
import Loader from "../components/Loader/Loader";

const AuthorPosts = () => {
  const [posts, setPost] = useState('');
  const [loading, setLoading] = useState(false);
  const { userId } = useParams();


  useEffect(() => {
    const getUserPosts = async () => {
      setLoading(true);
      try {
        const { data } = await axios.get(`${BASE_URL}/posts/user/posts/${userId}`)
        setPost(data.posts)
        
      }
      catch (error) {
        console.log(error)
      }finally{
        setLoading(false)
      }
    }
    getUserPosts();
  }, [userId]);

  return (
    loading ? (
      <Loader />
    ) : (
      <section className="posts">
        {posts.length > 0 ? (
          <div className="container posts__container">
            {posts.map((post) => (
              <PostItem key={post._id} post={post} />
            ))}
          </div>
        ) : (
          <div className="container center">
            <h2>No posts yet!</h2>
          </div>
        )}
      </section>
    )
  )
}

export default AuthorPosts